class MobileNavigation {
  constructor() {
    this.nav = document.querySelector('[data-mobile-nav]');
    this.triggers = document.querySelectorAll('.js-submenu-trigger');
    this.backButtons = document.querySelectorAll('[data-nav-back]');
    this.closeButton = document.querySelector('[data-close-nav]');
    this.hamburgerButton = document.querySelector('.hamburger-menu');
    
    if (!this.nav) return;
    this.init();
  }

  init() {
    this.hamburgerButton?.addEventListener('click', (e) => {
      e.preventDefault();
      this.openNav();
    });

    this.closeButton?.addEventListener('click', () => {
      this.closeNav();
    });

    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const submenuId = trigger.dataset.submenu;
        this.openSubmenu(submenuId);
      });
    });

    this.backButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.goBack(button);
      });
    });

    // Close on overlay click
    this.nav?.addEventListener('click', (e) => {
      if (e.target === this.nav) {
        this.closeNav();
      }
    });
  }

  openNav() {
    document.body.classList.add('mobile-nav-active');
    this.nav.classList.add('is-active');
  }

  closeNav() {
    document.body.classList.remove('mobile-nav-active');
    this.nav.classList.remove('is-active');
    // Reset all submenus
    document.querySelectorAll('.mobile-nav__level.is-active').forEach(submenu => {
      submenu.classList.remove('is-active');
    });
  }

  openSubmenu(submenuId) {
    const submenu = document.querySelector(`[data-submenu-id="${submenuId}"]`);
    if (submenu) {
      submenu.classList.add('is-active');
    }
  }

  goBack(button) {
    const currentLevel = button.closest('.mobile-nav__level');
    currentLevel.classList.remove('is-active');
  }
}

// Initialize the mobile navigation
if (typeof window !== 'undefined') {
  window.addEventListener('DOMContentLoaded', () => {
    new MobileNavigation();
  });
}

// Handle mobile viewport height
function setVH() {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

window.addEventListener('resize', setVH);
window.addEventListener('orientationchange', setVH);
setVH(); 